import { render, staticRenderFns } from "./CompanyAnnouncements.vue?vue&type=template&id=31de0a82&scoped=true"
import script from "./CompanyAnnouncements.vue?vue&type=script&lang=js"
export * from "./CompanyAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./CompanyAnnouncements.vue?vue&type=style&index=0&id=31de0a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de0a82",
  null
  
)

export default component.exports